import { Renderer } from './Renderer'
import { Ball } from './Ball'

import {
  PerspectiveCamera,
  DirectionalLight,
  AmbientLight,
  PlaneBufferGeometry,
  MeshBasicMaterial,
  Color,
  Scene,
  Vector3,
  Vector2,
  AxesHelper,
  Raycaster,
  Mesh
} from 'three'

const nbrBall = 40
const delayBall = 1

export class WebGL {
  constructor (el) {
    this.resize = this.resize.bind(this)
    this.tick = this.tick.bind(this)
    this.setMousePos = this.setMousePos.bind(this)

    // Rendering
    this.time = { date: 0, elapsed: 0, delta: 0 }
    this.mousePos = {x: 0, z:0}
    this.mousePosHistory = []
    this.scene = new Scene()
    this.camera = new PerspectiveCamera(45, 1, 1, 1000)
    this.camera.far = 200
    this.camera.position.x = 0
    this.camera.position.y = 80
    this.camera.position.z = 0
    this.camera.lookAt( new Vector3(0, 0, 0) )
    this.renderer = new Renderer(this.scene, this.camera)
    this.raycaster = new Raycaster()

    // Lighting
    this.ambientLight = new AmbientLight(0xffffff, 1.5)

    this.planeGeometry = new PlaneBufferGeometry( 1000, 1000, 1, 1 )
    this.planeMaterial = new MeshBasicMaterial({transparent: true, opacity: 0})
    this.plane = new Mesh(this.planeGeometry, this.planeMaterial)
    this.plane.rotation.x = -Math.PI * .5

    this.scene.add(
      this.ambientLight,
      this.plane
    )

    this.balls = []

    for (let i = 0 ; i < nbrBall; i++) {
      this.balls.push(new Ball({
        size: Math.random() * .2 + .1,
        index: i
      }))
      for (let j = 0; j < delayBall ; j++) {
        this.mousePosHistory.push({x: 0, z: 0})
      }
      this.scene.add(this.balls[i])
    }

    this.container = el
    this.container.appendChild(this.renderer.canvas)

    this.start()
  }

  tick () {
    this.update()
    this.renderer.render()
    this.frameID = requestAnimationFrame(this.tick)
  }

  start () {
    this.resize()
    this.tick()
    addEventListener('resize', this.resize, { passive: true })
  }

  setMousePos (pos) {
    pos = new Vector2(pos.x, pos.y)
    this.raycaster.setFromCamera( pos, this.camera )
    const intersects = this.raycaster.intersectObject( this.plane )

    if(intersects.length >= 1) {
      this.mousePos.x = intersects[0].point.x
      this.mousePos.z = -intersects[0].point.z
    }
  }

  update () {
    const date = Date.now()
    this.time.delta = date - (this.time.date || date)
    this.time.elapsed += this.time.delta
    this.time.date = date

    this.mousePosHistory.unshift({...this.mousePos})
    this.mousePosHistory.pop()

    for (let i = 0; i < nbrBall; i++) {
      this.balls[i].setTarget( this.mousePosHistory[i * delayBall], this.time.elapsed )
    }
  }

  resize () {
    this.renderer.resize()
  }
}
